import { useTranslation } from "react-i18next";
import {
  TEAM_OVERVIEW_RISK_MODE_AT_RISK,
  TEAM_OVERVIEW_RISK_MODE_GLOBAL,
} from "./playerRiskUtils";

export default function PlayerRiskModeToggle({
  isDarkMode,
  riskMode,
  onChange,
  className = "",
}) {
  const { t } = useTranslation();
  const isAtRiskMode = riskMode === TEAM_OVERVIEW_RISK_MODE_AT_RISK;

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-lg border px-2 py-1.5 ${
        isDarkMode ? "border-gray-600 bg-gray-800" : "border-gray-300 bg-white"
      } ${className}`}
    >
      <span className={`text-[11px] font-semibold uppercase tracking-wide ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
        {t("team_overview.players_scope", { defaultValue: "Players" })}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={isAtRiskMode}
        onClick={() =>
          onChange(
            isAtRiskMode
              ? TEAM_OVERVIEW_RISK_MODE_GLOBAL
              : TEAM_OVERVIEW_RISK_MODE_AT_RISK
          )
        }
        title={
          isAtRiskMode
            ? t("team_overview.risk_mode_at_risk", { defaultValue: "At-risk" })
            : t("team_overview.risk_mode_global", { defaultValue: "Global" })
        }
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${
          isAtRiskMode ? "bg-rose-500" : isDarkMode ? "bg-gray-600" : "bg-gray-400"
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
            isAtRiskMode ? "translate-x-5" : "translate-x-1"
          }`}
        />
      </button>
      <span className={`text-xs font-medium ${isAtRiskMode ? isDarkMode ? "text-rose-300" : "text-rose-700" : isDarkMode ? "text-gray-200" : "text-gray-700"}`}>
        {isAtRiskMode
          ? t("team_overview.risk_mode_at_risk", { defaultValue: "At-risk" })
          : t("team_overview.risk_mode_global", { defaultValue: "Global" })}
      </span>
    </div>
  );
}
